import { useCallback, useMemo, useRef, useState } from 'react'

/** A response belongs to its request, even before the next effect has run. */
export function useRequestState<T>(key: string, initial: T): [T, (value: T) => void] {
  // A→B→A is a new request too; a string match alone can revive the first A.
  const request = useMemo(() => ({ key }), [key])
  const current = useRef(request)
  current.current = request
  const [result, setResult] = useState({ request, value: initial })
  const setValue = useCallback((value: T) => {
    if (current.current === request) setResult({ request, value })
  }, [request])
  return [result.request === request ? result.value : initial, setValue]
}
